module.exports = __webpack_public_path__ + "static/img/google-play.3cd9a4b2.png";